import * as React from "react";
import {
    Card,
    CardBody,
    CardTitle,
    Badge,
    ButtonDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Form,
    FormGroup,
    Label,
    Input,
    Button,
    ButtonGroup,
    ButtonToolbar,
    Dropdown
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faPlusSquare,
    faFile,
    faInfoCircle,
    faExpandArrowsAlt,
    faSave,
    faSearch,
    faCameraRetro,
    faClock,
    faUpload,
    faDownload,
    faRedo,
    faToggleOn,
    faToggleOff
} from "@fortawesome/free-solid-svg-icons";

import Widgets, {
    Widget,
    WidgetField,
    getWidgetColor,
    getWidgetForeColor,
    populateDefaultFields
} from "./widgets";

import { Typeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";

import { settings } from "settings";

import i18n from "../i18n";

import "./toolbox.css";
import {
    DefaultNodeModel,
    DefaultLinkModel,
    DefaultLabelModel,
    DiagramModel
} from "storm-react-diagrams";
import WIDGETS from "./widgets";

import OpenScenario from "./open-scenario";
import { ScenarioModel } from "models/scenario";
import EditJson from "designer/edit-json";
import { getAsync } from "utils/net";
import { formatRelative } from "date-fns";
import { Channels } from "utils/channels";
import { checkUser, checkRole } from "security/security";

interface ToolboxProps {
    show: boolean;
    selectedElement?: DefaultNodeModel | DefaultLinkModel | ScenarioModel | null;
    currentScenarioModel: DiagramModel;
    currentScenario: ScenarioModel | null;
    currentScenarioHasChanges: boolean;
    isNewScenario: boolean;
    scenarios: any[];
    locked: boolean;
    onNewNode: (type: string) => void;
    onChangeNodeType: (type: string) => void;
    onNewScenario: () => void;
    onItemUpdate?: (field: WidgetField, value: string) => void;
    onOpenScenario: (model: ScenarioModel | null) => void;
    onSaveScenario: () => void;
    onUpdateScenario: (model: ScenarioModel) => void;
    onEditJson: (json: string) => void;
    onZoomToFit: () => void;
    onCopyAsImage: () => void;
    onShowHistory: () => void;
    onCheckinScenario: () => void;
    onCheckoutScenario: () => void;
    onReloadLatest: () => void;
    onSearch: () => void;
}
interface ToolboxState {
    selectedElement?: DefaultNodeModel | DefaultLinkModel | ScenarioModel | null;
    dropdownOpen: boolean;
    changeTypeDropdownOpen: boolean;
    intents: any[];
    entities: any[];
    securityVariables: any[];
    channels: string[];
    showAdvanced: boolean;
}

export default class Toolbox extends React.Component<
    ToolboxProps,
    ToolboxState
    > {
    constructor(props: ToolboxProps) {
        super(props);
        this.state = {
            selectedElement: props.selectedElement,
            dropdownOpen: false,
            changeTypeDropdownOpen: false,
            intents: [],
            entities: [],
            securityVariables: [],
            channels: settings.channels,
            showAdvanced: false
        };
    }

    componentDidMount() {
        this.loadLUISModels();
    }

    componentWillReceiveProps(nextProps: ToolboxProps) {
        this.setState({
            selectedElement: nextProps.selectedElement
        });
    }

    render() {
        const { isNewScenario, show } = this.props;
        const { selectedElement } = this.state;
        const isGraphElement =
            selectedElement instanceof DefaultLinkModel ||
            selectedElement instanceof DefaultNodeModel;
        // const isLink = selectedElement instanceof DefaultLinkModel;

        return (
            <div className={`designer-toolbox ${!show ? "hidden" : ""}`}>
                <Card>
                    <CardBody>
                        <CardTitle>Toolbox</CardTitle>
                        <div className="card-text">
                            <ButtonToolbar>
                                <ButtonGroup>
                                    <Button
                                        color="primary"
                                        title="New scenario"
                                        onClick={() => this.props.onNewScenario()}
                                    >
                                        <FontAwesomeIcon icon={faFile} />
                                    </Button>
                                    <OpenScenario
                                        scenarios={this.props.scenarios}
                                        onSelected={model => this.props.onOpenScenario(model)}
                                    />
                                    {(!this.props.isNewScenario && this.props.currentScenario) && (
                                        <Button
                                            color="primary"
                                            title="Reload latest version of the current scenario"
                                            onClick={() => this.props.onReloadLatest()}
                                        >
                                            <FontAwesomeIcon icon={faRedo} />
                                        </Button>
                                    )}
                                    {(this.props.isNewScenario ||
                                        (this.props.currentScenario &&
                                            this.props.currentScenario.checkedOutBy &&
                                            this.props.currentScenarioHasChanges &&
                                            checkUser(this.props.currentScenario.checkedOutBy))) && (
                                            <Button
                                                color="primary"
                                                title="Save scenario"
                                                onClick={() => this.props.onSaveScenario()}
                                            >
                                                <FontAwesomeIcon icon={faSave} />
                                            </Button>
                                        )}
                                    {!this.props.isNewScenario &&
                                        this.props.currentScenario &&
                                        this.props.currentScenario.checkedOutBy &&
                                        checkUser(this.props.currentScenario.checkedOutBy) &&
                                        !this.props.currentScenarioHasChanges && (
                                            <Button
                                                color="warning"
                                                title="Checkin scenario"
                                                onClick={() => this.props.onCheckinScenario()}
                                            >
                                                <FontAwesomeIcon icon={faUpload} />
                                            </Button>
                                        )}
                                    {(checkRole("Designer.Change") &&
                                        !this.props.isNewScenario &&
                                        this.props.currentScenario
                                        && !checkUser(this.props.currentScenario.checkedOutBy)) && (
                                            <Button
                                                color={!this.props.currentScenario.checkedOutBy
                                                    || checkUser(this.props.currentScenario.checkedOutBy)
                                                    ? "warning" : "danger"}
                                                title="Checkout scenario"
                                                onClick={() => this.props.onCheckoutScenario()}
                                            >
                                                <FontAwesomeIcon icon={faDownload} />
                                            </Button>
                                        )}
                                    {/* )} */}
                                    {this.props.currentScenario &&
                                        (<EditJson
                                            onSave={(json: string) => this.props.onEditJson(json)}
                                            currentScenarioModel={this.props.currentScenarioModel}
                                        />)}
                                    <Button
                                        color="primary"
                                        title="Zoom"
                                        onClick={() => this.props.onZoomToFit()}
                                    >
                                        <FontAwesomeIcon icon={faExpandArrowsAlt} />
                                    </Button>
                                    <Button
                                        color="primary"
                                        title="Search"
                                        onClick={() => this.props.onSearch()}
                                    >
                                        <FontAwesomeIcon icon={faSearch} />
                                    </Button>
                                    <Button
                                        color="primary"
                                        title="Copy as image"
                                        onClick={() => this.props.onCopyAsImage()}
                                    >
                                        <FontAwesomeIcon icon={faCameraRetro} />
                                    </Button>
                                    {(this.props.currentScenario &&
                                        this.props.currentScenario.checkedOutBy &&
                                        checkUser(this.props.currentScenario.checkedOutBy)) &&
                                        (<Button
                                            color="primary"
                                            title="Show history"
                                            onClick={() => this.props.onShowHistory()}
                                        >
                                            <FontAwesomeIcon icon={faClock} />
                                        </Button>)}
                                    <ButtonDropdown
                                        isOpen={this.state.dropdownOpen}
                                        toggle={() => this.toggle()}
                                        size="sm"
                                    >
                                        <DropdownToggle color="success" caret={true}>
                                            <FontAwesomeIcon icon={faPlusSquare} />
                                        </DropdownToggle>
                                        <DropdownMenu>
                                            {this.widgets.map(w => (
                                                <DropdownItem
                                                    onClick={() => this.props.onNewNode(w.Type)}
                                                    key={`newnode_${w.Type}`}
                                                >
                                                    {w.Type}
                                                </DropdownItem>
                                            ))}
                                        </DropdownMenu>
                                    </ButtonDropdown>
                                </ButtonGroup>
                            </ButtonToolbar>
                            {!selectedElement && (
                                <div>{i18n.Designer.Toolbox.PleaseSelect}</div>
                            )}
                            {selectedElement &&
                                isGraphElement && (
                                    <div>
                                        <Dropdown
                                            isOpen={this.state.changeTypeDropdownOpen}
                                            toggle={() => this.toggleChangeNodeType()}
                                            size="sm"
                                        >
                                            <DropdownToggle tag="span">
                                                <Badge
                                                    style={{
                                                        backgroundColor: getWidgetColor(
                                                            this.itemPayload.type
                                                        ),
                                                        color: getWidgetForeColor(this.itemPayload.type)
                                                    }}
                                                    pill={true}
                                                >
                                                    {this.displayName}
                                                </Badge>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                {this.widgets.map(w => (
                                                    <DropdownItem
                                                        onClick={() => this.props.onChangeNodeType(w.Type)}
                                                        key={`editnode_${w.Type}`}
                                                    >
                                                        {w.Type}
                                                    </DropdownItem>
                                                ))}
                                            </DropdownMenu>
                                        </Dropdown>
                                        <Form
                                            className={settings.disableScenarioSave ? "no-touch" : ""}
                                        >
                                            {this.fields.filter(f => !f.advanced).map(f => this.renderFullField(f))}
                                            {this.fields.filter(f => f.advanced).length > 0 &&
                                                (this.renderAdvancedField())}
                                        </Form>
                                    </div>
                                )}
                            {selectedElement &&
                                !isGraphElement &&
                                !isNewScenario && (
                                    <Form
                                        className={settings.disableScenarioSave ? "no-touch" : ""}
                                    >
                                        <FormGroup>
                                            <Label>Current Scenario Name</Label>
                                            <p>{(selectedElement as ScenarioModel).partitionKey}</p>
                                        </FormGroup>
                                        {!!(selectedElement as ScenarioModel).rowKey && (
                                            <FormGroup inline={true}>
                                                <Label inline={true}>Version</Label>
                                                {" "}
                                                <span>
                                                    {formatRelative(
                                                        new Date(
                                                            (selectedElement as ScenarioModel).timestamp || ""
                                                        ),
                                                        new Date()
                                                    )}
                                                </span>
                                            </FormGroup>
                                        )}
                                        <FormGroup inline={true}>
                                            <Label inline={true}>Changed By</Label>
                                            {" "}
                                            <span>{(selectedElement as ScenarioModel).changedBy}</span>
                                        </FormGroup>
                                        <FormGroup inline={true}>
                                            <Label inline={true}>Checked Out By</Label>
                                            {" "}
                                            <span>{(selectedElement as ScenarioModel).checkedOutBy}</span>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {i18n.Scenarios.Table.Category}
                                                <Input
                                                    size={"50" as any}
                                                    value={this.scenario.category}
                                                    onChange={e =>
                                                        this.updateScenarioField("category", e)
                                                    }
                                                    disabled={this.props.locked}
                                                />
                                            </Label>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.Scenarios.Table.Intents}</Label>
                                            <Typeahead
                                                multiple={true}
                                                labelKey="display"
                                                bsSize="sm"
                                                selected={(this.scenario.intents || "")
                                                    .split(",")
                                                    .filter((s: string) => !!s)}
                                                allowNew={true}
                                                options={this.state.intents}
                                                selectHintOnEnter={true}
                                                onChange={e =>
                                                    this.updateScenarioField("intents", null, e)
                                                }
                                                disabled={this.props.locked}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.Scenarios.Table.Entities}</Label>
                                            <Typeahead
                                                multiple={true}
                                                labelKey="display"
                                                bsSize="sm"
                                                selected={(this.scenario.entities || "")
                                                    .split(",")
                                                    .filter((s: string) => !!s)}
                                                allowNew={true}
                                                options={this.state.entities}
                                                selectHintOnEnter={true}
                                                onChange={e =>
                                                    this.updateScenarioField("entities", null, e)
                                                }
                                                disabled={this.props.locked}
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {i18n.Scenarios.Table.Keywords}
                                                <Input
                                                    size={"50" as any}
                                                    value={this.scenario.keywords || ""}
                                                    onChange={e =>
                                                        this.updateScenarioField("keywords", e)
                                                    }
                                                    disabled={this.props.locked}
                                                />
                                            </Label>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>
                                                {i18n.Scenarios.Table.Languages}
                                                <Input
                                                    size={"50" as any}
                                                    value={this.scenario.languages}
                                                    onChange={e =>
                                                        this.updateScenarioField("languages", e)
                                                    }
                                                    disabled={this.props.locked}
                                                />
                                            </Label>
                                        </FormGroup>
                                        <FormGroup>
                                            <Label>{i18n.Scenarios.Table.Channels}</Label>
                                            <Channels
                                                model={this.scenario}
                                                onChange={(c, e) => this.updateChannels(c, e)}
                                                locked={this.props.locked}
                                            />
                                        </FormGroup>
                                    </Form>
                                )}
                        </div>
                    </CardBody>
                </Card>
            </div>
        );
    }

    get scenario() {
        return this.state.selectedElement as ScenarioModel;
    }

    private renderAdvancedField() {
        return (
            <div>
                <span>
                    <Button color="primary" onClick={() => this.toggleToolbox()}>
                        <FontAwesomeIcon icon={this.state.showAdvanced ? faToggleOn : faToggleOff} />
                    </Button>
                    <Label>  {this.state.showAdvanced ? "Advanced" : "Basic"} options</Label>
                </span>
                <div style={!this.state.showAdvanced ? { display: "none" } : {}}>
                    {this.fields.filter(f => f.advanced).map(f => this.renderFullField(f))}
                </div>
            </div>
        );
    }

    private toggleToolbox() {
        this.setState({
            showAdvanced: !this.state.showAdvanced
        });
    }

    private renderFullField(f: WidgetField) {
        return (
            <FormGroup key={`field_${f.label || f.name}`}>
                <Label
                    dangerouslySetInnerHTML={{
                        __html: f.label || f.name
                    }}
                />
                {f.description && (
                    <i title={(f.description || "")}>
                        <FontAwesomeIcon icon={faInfoCircle} />
                    </i>
                )}
                {this.renderField(f)}
            </FormGroup>
        );
    }

    private renderField(f: WidgetField) {
        switch (f.type) {
            case "multiline":
                return (
                    <textarea
                        className="form-control-sm form-control"
                        rows={5}
                        cols={40}
                        onChange={e => this.updateItem(e, f)}
                        value={this.itemPayload[f.serializeTo || f.name] || ""}
                        disabled={this.props.locked}
                    />
                );

            case "intents":
                return (
                    <Typeahead
                        multiple={true}
                        labelKey="name"
                        bsSize="sm"
                        selected={(this.itemPayload[f.serializeTo || f.name] || "")
                            .split(",")
                            .filter((s: string) => !!s)}
                        allowNew={true}
                        options={this.state.intents}
                        selectHintOnEnter={true}
                        onChange={e => this.updateItem(e, f)}
                        disabled={this.props.locked}
                    />
                );
            case "scenario":
                return (
                    <Typeahead
                        labelKey="name"
                        bsSize="sm"
                        selected={(this.itemPayload[f.serializeTo || f.name] || "")
                            .split(",")
                            .filter((s: string) => !!s)}
                        allowNew={true}
                        options={this.scenarioList}
                        selectHintOnEnter={true}
                        onChange={e => this.updateItem(e, f)}
                        disabled={this.props.locked}
                    />
                );
            case "intent":
                return (
                    <Typeahead
                        multiple={true}
                        labelKey="name"
                        bsSize="sm"
                        selected={(this.itemPayload[f.serializeTo || f.name] || "")
                            .split(",")
                            .filter((s: string) => !!s)}
                        allowNew={true}
                        options={this.state.intents}
                        selectHintOnEnter={true}
                        onChange={e => this.updateItem(e, f)}
                        disabled={this.props.locked}
                    />
                );

            case "entities":
                return (
                    <Typeahead
                        multiple={true}
                        labelKey="name"
                        bsSize="sm"
                        selected={(this.itemPayload[f.serializeTo || f.name] || "")
                            .split(",")
                            .filter((s: string) => !!s)}
                        allowNew={true}
                        options={this.state.entities}
                        selectHintOnEnter={true}
                        onChange={e => this.updateItem(e, f)}
                        disabled={this.props.locked}
                    />
                );
            case "msisdn":
                return (
                    <select
                        className="form-control form-control-sm"
                        onChange={e => this.updateItem(e, f)}
                        value={this.itemPayload[f.serializeTo || f.name] || ""}
                        disabled={this.props.locked}
                    >
                        <option value="" />
                        <option value="msisdn">msisdn</option>
                        <option value="cli">cli</option>
                        <option value="msisdn,cli">msisdn/cli</option>
                    </select>
                );

            case "yesno":
                return (
                    <select
                        className="form-control form-control-sm"
                        onChange={e => this.updateItem(e, f)}
                        value={this.itemPayload[f.serializeTo || f.name] || f.defaultValue || ""}
                        disabled={this.props.locked}
                    >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                    </select>
                );

            case "choice":
                return (
                    <select
                        className="form-control form-control-sm"
                        onChange={e => this.updateItem(e, f)}
                        value={this.itemPayload[f.serializeTo || f.name] || ""}
                        disabled={this.props.locked}
                    >
                        {f.choices &&
                            f.choices.map(c => (
                                <option key={c} value={c}>
                                    {c}
                                </option>
                            ))}
                    </select>
                );

            default:
                return (
                    <Input
                        type="text"
                        bsSize="sm"
                        autoComplete="off"
                        onChange={e => this.updateItem(e, f)}
                        value={this.itemPayload[f.serializeTo || f.name] || f.defaultValue || ""}
                        disabled={this.props.locked}
                    />
                );
        }
    }

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }
    toggleChangeNodeType() {
        this.setState({
            changeTypeDropdownOpen: !this.state.changeTypeDropdownOpen
        });
    }

    get scenarioList(): any[] {
        return this.props.scenarios.map(s => ({
            id: s.partitionKey,
            name: s.partitionKey
        }));
    }

    get widgets(): Widget[] {
        return Object.keys(WIDGETS)
            .filter(k => k !== "SecurityLogin")
            .map(k => populateDefaultFields(WIDGETS[k]))
            .filter(w => !w.Disabled);
    }

    get displayName(): string {
        const item = this.state.selectedElement;
        if (item instanceof DefaultNodeModel) {
            return (item as DefaultNodeModel).name;
        }
        if (item instanceof DefaultLinkModel) {
            const link = item as DefaultLinkModel;
            return link.labels.length > 0
                ? (link.labels[0] as DefaultLabelModel).label
                : "Link";
        }

        return "N/A";
    }

    get fields(): WidgetField[] {
        const item = this.state.selectedElement;
        if (item instanceof DefaultNodeModel) {
            const node = item as DefaultNodeModel;
            return Widgets[node.name].Fields.filter(f => this.evaluateFieldShow(f));
        }
        if (item instanceof DefaultLinkModel) {
            return require("./widgets/Link.json").Fields;
        }

        return [];
    }

    private evaluateFieldShow(f: WidgetField) {
        if (!f.show) {
            return true;
        }

        return f.show.every(condition => {
            const fieldValue = this.itemPayload[condition.when];
            if (typeof condition.is === "string") {
                return fieldValue === condition.is;
            } else if (condition.is instanceof Array) {
                return condition.is.filter(val => fieldValue === val).length > 0;
            }
            return false;
        });
    }

    get itemPayload(): any {
        const item = this.state.selectedElement;
        if (item instanceof DefaultLinkModel || item instanceof DefaultNodeModel) {
            return item.extras;
        }

        return {};
    }

    private updateItem(
        e:
            | React.ChangeEvent<HTMLInputElement>
            | React.ChangeEvent<HTMLSelectElement>
            | React.ChangeEvent<HTMLTextAreaElement>
            | any[],
        field: WidgetField
    ) {
        const item = this.state.selectedElement;
        const fieldId = field.serializeTo || field.name;
        if (
            item &&
            (item instanceof DefaultLinkModel || item instanceof DefaultNodeModel)
        ) {
            let value: any;
            if (e instanceof Array) {
                value = e.map(x => (x.name ? x.name : x)).join(",");
            } else {
                value = e.target.value;
            }
            item.extras[fieldId] = value;
            this.props.onItemUpdate && this.props.onItemUpdate(field, value);
        }
    }

    private updateScenarioField(
        field: string,
        e: React.ChangeEvent<HTMLInputElement> | null,
        value?: any
    ) {
        const temp: any = {};
        switch (field) {
            case "intents":
            case "entities":
                temp[field] = value.map((x: any) => 
                (this.getName(x, x.display) ? this.getName(x, x.display) : x)).join(",");
                break;
            default:
                temp[field] = e ? e.target.value : value;
                break;
        }
        const newModel = {
            ...this.state.selectedElement,
            ...temp
        };
        // this.setState({
        //   selectedElement: newModel,
        // });
        this.props.onUpdateScenario &&
            this.props.onUpdateScenario(newModel as ScenarioModel);
    }
    private updateChannels(
        channel: string,
        e: React.ChangeEvent<HTMLInputElement>
    ) {
        const { selectedElement } = this.state;
        if (
            !(
                selectedElement instanceof DefaultLinkModel ||
                selectedElement instanceof DefaultNodeModel
            )
        ) {
            let list: string[] = [];
            if (channel === "*") {
                if (e.target.checked) {
                    list.push("*");
                }
            } else {
                list = ((selectedElement && selectedElement.channels) || "")
                    .split(",")
                    .filter((c: string) => !!c);
                if (e.target.checked) {
                    list.push(channel);
                } else {
                    list = list.filter(c => c !== channel);
                }
            }

            this.updateScenarioField("channels", null, list.join(","));
        }
    }
    private getDisplayLuisItem(luisItem: any, suffix: string) {
        if (luisItem.prefixName) {
            return `${luisItem.prefixName}.${suffix}`;
        } else if (luisItem.modelId) {
            return `${luisItem.modelId}.${suffix}`;
        } else {
            return suffix;
        }
    }

    private getName(luisItem: any, display: string) {
        if (luisItem.prefixName || luisItem.modelId) {
        return luisItem.name;
        } else if (display !== undefined && display.includes(".")) {
        return display.substring(
            display.lastIndexOf(".") + 1, 
            display.length);
        } else {
        return display;
        }
    }

    private async loadLUISModels() {
        const reply = await getAsync("/api/luis/models");
        const payload: any[] = await reply.json();

        this.setState({
            intents: [
                { id: "*", name: "*", display: "*" },
                ...payload
                    .filter(x => /intent/i.test(x.readableType))
                    .map(x => {
                        x.display = this.getDisplayLuisItem(x, x.name);
                        return x;
                    })
            ],
            entities: [
                { id: "*", name: "*", display: "*" },
                ...payload
                    .filter(x => /entity/i.test(x.readableType))
                    .map(x => {
                        if (x.subLists) {
                            return x.subLists.map((y: any) => ({
                                id: x.id,
                                name: `${x.name}:${y.canonicalForm}`,
                                display: this.getDisplayLuisItem(x, `${x.name}:${y.canonicalForm}`)
                            }));
                        } else {
                            return {
                                id: x.id,
                                name: x.name,
                                display: this.getDisplayLuisItem(x, x.name)
                            };
                        }
                    })
                    .reduce((s, v) => [...s, ...v], [])
            ]
        });
    }
}



// WEBPACK FOOTER //
// ./src/designer/toolbox.tsx